import { CircularProgress, MenuItem, Skeleton, TextField, Autocomplete, Typography } from '@mui/material';
import { renderValueSupplierId } from '../../utils/utils';
import { Controller } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { collection, orderBy, query } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useCollection } from 'react-firebase-hooks/firestore';

const FieldSupplierAutocomplete = ({ control, name, disabled, label, disableClear, setValue, rules }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const suppliersDocRef = query(collection(db, 'suppliers'), orderBy('name'));

  const [suppliersSnapshot, loadingRef] = useCollection(suppliersDocRef);
  // const [customersSnapshot, loading] = useCollectionData(customersDocRef);

  useEffect(() => {
    const fetchSuppliers = async () => {
      if (suppliersSnapshot) {
        const suppliersData = await Promise.all(
          suppliersSnapshot.docs.map(async (supplierDoc) => {
            const supplierData = supplierDoc.data();
            return { id: supplierDoc.id, ...supplierData };
          }),
        );
        setSuppliers(suppliersData);
        setLoading(false);
      }
    };
    // if (ordersSnapshot?.docs.length > 0) {
    //   const lastVisibleDoc = ordersSnapshot.docs[ordersSnapshot.docs.length - 1];
    //   setLastVisible(lastVisibleDoc);
    // }
    setLoading(true);
    fetchSuppliers().then();
    // console.log(customersSnapshot);
  }, [suppliersSnapshot]);

  if (loading)
    return (
      <Skeleton
        variant={'rounded'}
        animation="wave"
        sx={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomStyle: 'solid',
          borderBottomWidth: 1,
          borderBottomColor: 'divider',
        }}
        height={56}
      />
    );
  return (
    // <Controller
    //   name={name}
    //   defaultValue=""
    //   control={control}
    //   rules={rules}
    //   render={({ field }) => (
    //     <TextField
    //       {...field}
    //       label={label}
    //       variant="filled"
    //       fullWidth
    //       disabled={disabled}
    //       select
    //       slotProps={{
    //         input: {
    //           endAdornment:
    //             field.value && !disableClear ? (
    //               <InputAdornment position="end">
    //                 <IconButton
    //                   onClick={() => setValue(field.name, '')}
    //                   edge="end"
    //                 >
    //                   <Clear />
    //                 </IconButton>
    //               </InputAdornment>
    //             ) : null,
    //         },
    //       }}
    //       // slotProps={{
    //       //   input: {
    //       //     endAdornment: !loading ? (
    //       //       <CircularProgress
    //       //         color="inherit"
    //       //         size={24}
    //       //       />
    //       //     ) : null,
    //       //   },
    //       // }}
    //     >
    //       {customersSnapshot?.docs.map((doc) => {
    //         const customerSnap = doc.data();
    //         return (
    //           <MenuItem
    //             key={doc.id}
    //             value={doc.id}
    //           >
    //             {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
    //             <Typography variant="inherit">{renderValueCustomerId(customerSnap)}</Typography>
    //           </MenuItem>
    //         );
    //       })}
    //     </TextField>
    //   )}
    // />
    <Controller
      name={name}
      defaultValue=""
      control={control}
      rules={rules}
      render={({ field }) => {
        const selectedCustomer = suppliers ? suppliers.find((customer) => customer.id === field.value) : '';
        // console.log('selectedCustomer', selectedCustomer, customers);
        return (
          <Autocomplete
            loading={loading}
            disabled={disabled}
            disableClearable={disableClear}
            onChange={(event, newValue) => {
              return field.onChange(newValue ? newValue.id : '');
            }}
            value={selectedCustomer || null}
            options={suppliers || []}
            autoComplete
            getOptionLabel={(option) => {
              return `${option.phone} - ${option.name}`;
            }}
            renderOption={(props, option) => (
              <MenuItem
                {...props}
                key={option.id}
                value={option.id}
              >
                {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
                <Typography variant="inherit">{renderValueSupplierId(option)}</Typography>
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="filled"
                fullWidth
                disabled={disabled}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                          />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  },
                }}
                // slotProps={{
                //   input: {
                //     endAdornment: !loading ? (
                //       <CircularProgress
                //         color="inherit"
                //         size={24}
                //       />
                //     ) : null,
                //   },
                // }}
              />
            )}
          />
        );
      }}
    />
  );
};

export default FieldSupplierAutocomplete;
